import { apiAxios } from 'utils/axios';
import { useDispatch, useSelector } from 'react-redux';
import { userLoggedIn } from 'store/features/auth/authSlice';

const useRefreshToken = () => {
	const auth = useSelector((state) => state.auth);
	const dispatch = useDispatch();

	const refresh = async () => {
		try {
			const response = await apiAxios.post('/authentication-service/endpoint/oauth/createRefreshToken', { token: auth.refreshToken });

			const data = response.data?.result?.authResponse;

			dispatch(
				userLoggedIn({
					accessToken: data?.id_token,
					refreshToken: data?.refresh_token,
					userId: auth?.userId,
					roleId: auth?.roleId,
					roleName: auth?.roleName,
				})
			);

			return data;
		} catch (error) {
			// console.log(error);
		}
	};

	return refresh;
};

export default useRefreshToken;
